import {UNDERWRITING_BASE_URL} from '../constants/global';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import {fetchParams} from '../constants/fetchParams';

export function getIndustries() {
  return authenticatedFetch(`${UNDERWRITING_BASE_URL()}api/v2/industries`, fetchParams())
    .then(response => response.json())
    .then(parseJsonResponse);
}

const parseJsonResponse = json => json.map(({ name }) => ({ value: name, label: name }));
